import axios from "axios";

// Actions
export const CONSENT_DATE_TIME_SUCCESS = "consent-date/SUCCESS";
export const CONSENT_DATE_TIME_REQUEST = "consent-date/REQUEST";
export const CONSENT_DATE_TIME_FAILURE = "consent-date/FAILURE";

// Reducer
export const initialState = {
  data: null,
  error: null,
  loading: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CONSENT_DATE_TIME_REQUEST:
      return {
        ...initialState,
        loading: true
      };
    case CONSENT_DATE_TIME_SUCCESS:
      return {
        ...initialState,
        data: action.payload,
        loading: false
      };
    case CONSENT_DATE_TIME_FAILURE:
      return {
        ...initialState,
        error: action.payload,
        loading: false
      };
    default:
      return state;
  }
}

export const fetchConsentDateTime = (platform = "ehost") => async (
  dispatch,
  getState
) => {
  const {
    paths: { api },
    personalUser: { puaId }
  } = getState();
  dispatch(fetchConsentDateTimeRequest());
  try {
    const consentTimestampResponse = await axios.get(
      `${api}/v2/consent?userId=${puaId}`
    );
    dispatch(fetchConsentDateTimeSuccess(consentTimestampResponse.data));
  } catch (error) {
    dispatch(fetchConsentDateTimeFailure(error));
  }
};

export const fetchConsentDateTimeRequest = () => ({
  type: CONSENT_DATE_TIME_REQUEST
});
export const fetchConsentDateTimeSuccess = data => ({
  type: CONSENT_DATE_TIME_SUCCESS,
  payload: data.lastModified
});
export const fetchConsentDateTimeFailure = error => ({
  type: CONSENT_DATE_TIME_FAILURE,
  payload: error
});

// Selectors
export const getConsentDateTime = state => {
  return state.consentDateTime.data;
};
